import { render, staticRenderFns } from "./TableListInvites.vue?vue&type=template&id=867fd5e6&scoped=true&"
import script from "./TableListInvites.vue?vue&type=script&lang=js&"
export * from "./TableListInvites.vue?vue&type=script&lang=js&"
import style0 from "./TableListInvites.vue?vue&type=style&index=0&id=867fd5e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867fd5e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('867fd5e6')) {
      api.createRecord('867fd5e6', component.options)
    } else {
      api.reload('867fd5e6', component.options)
    }
    module.hot.accept("./TableListInvites.vue?vue&type=template&id=867fd5e6&scoped=true&", function () {
      api.rerender('867fd5e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/InviteFacematchHive/components/TableListInvites.vue"
export default component.exports